<template>
  <div
    v-if="hasAccess"
    class="fill-height"
  >
    <v-row>
      <v-col
        v-for="(item, key) in data"
        :key="key"
        cols="12"
        sm="4"
        md="3"
        xl="2"
      >
        <v-card
          max-width="300"
          class="mx-auto"
        >
          <v-card-title class="justify-center pb-0">
            <div class="font-weight-medium text-center">
              {{ item.machineDisplayName }}
            </div>
          </v-card-title>
          <v-card-title class="justify-center pt-0">
            <div class="title font-weight-regular text-center">
              {{ item.machineDisplayIdentifier }}
            </div>
          </v-card-title>
          <v-divider class="mx-2" />
          <v-card-text class="text-center">
            <v-chip
              v-if="getStatus(item.current.on, item.current.working) === 'working'"
              class="title font-weight-regular"
              color="green lighten-2"
            >
              {{ $vuetify.lang.t('$vuetify.working') }}
            </v-chip>
            <v-chip
              v-else-if="getStatus(item.current.on, item.current.working) === 'stop'"
              class="title font-weight-regular"
              color="red lighten-2"
            >
              {{ $vuetify.lang.t('$vuetify.stop') }}
            </v-chip>
            <v-chip
              v-else
              class="title font-weight-regular"
              color="grey lighten-2"
            >
              {{ $vuetify.lang.t('$vuetify.off') }}
            </v-chip>
          </v-card-text>
          <v-divider class="mx-2" />
          <v-card-text class="text-center">
            <div class="subtitle-2 font-weight-bold mb-2">
              {{ `${$vuetify.lang.t('$vuetify.on')}/${$vuetify.lang.t('$vuetify.working')}` }}
            </div>
            <v-row
              align="center"
              no-gutters
            >
              <v-col
                cols="6"
                class="title font-weight-medium"
              >
                <div class="subtitle-2 font-weight-regular">
                  {{ `${$vuetify.lang.t('$vuetify.last')} 24h` }}
                </div>
                {{ objectPath().get(item, 'last24Hours.percent', '0') }}%
              </v-col>
              <v-col
                cols="6"
                class="title font-weight-medium"
              >
                <div class="subtitle-2 font-weight-regular">
                  {{ `${$vuetify.lang.t('$vuetify.last')} 7d` }}
                </div>
                {{ objectPath().get(item, 'lastSevenDays.percent', '0') }}%
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="mx-2" />
          <v-card-text class="text-center">
            <div class="subtitle-2 font-weight-bold mb-2">
              {{ `${$vuetify.lang.t('$vuetify.start')}/${$vuetify.lang.t('$vuetify.stop')}` }}
            </div>
            <v-row
              align="center"
              no-gutters
            >
              <v-col
                cols="6"
                class="title font-weight-medium"
              >
                <div class="subtitle-2 font-weight-regular">
                  {{ `${$vuetify.lang.t('$vuetify.last')} 24h` }}
                </div>
                {{ objectPath().get(item, 'last24Hours.startStop', '0') }}
              </v-col>
              <v-col
                cols="6"
                class="title font-weight-medium"
              >
                <div class="subtitle-2 font-weight-regular">
                  {{ `${$vuetify.lang.t('$vuetify.last')} 7d` }}
                </div>
                {{ objectPath().get(item, 'lastSevenDays.startStop', '0') }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import objectPath from 'object-path';
import apiUtil from '../utils/ApiUtil';
import { Class as PollerUtil } from '../utils/PollerUtil';

export default {
  data() {
    return {
      permissionsKey: 7,
      pollerUtil: new PollerUtil(),
      data: {},
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    await this.refresh();
    this.$store.dispatch('setGlobalLoading', false);

    this.pollerUtil.interval(1000).exec(
      async () => {
        await this.refresh();
      },
    );
  },
  async destroyed() {
    this.pollerUtil.end();
  },
  methods: {
    objectPath() {
      return objectPath;
    },
    async refresh() {
      const response = await apiUtil.getStatOverview();
      this.data = response;
    },
    getStatus(on, working) {
      let result = '';
      if (on === '0') {
        result = 'off';
      }
      if (on === '1' && working === '1') {
        result = 'working';
      }
      if (on === '1' && working === '0') {
        result = 'stop';
      }
      return result;
    },
  },
};
</script>
